import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterOutlet } from '@angular/router';
import { AvatarModule } from 'primeng/avatar';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { ToolbarModule } from 'primeng/toolbar';
import { DevicelistComponent } from '../../Components/devicelist/devicelist.component';
import { TerminalComponent } from '../../Components/terminal/terminal.component';
import { DividerModule } from 'primeng/divider';
import { PanelModule } from 'primeng/panel';
import { ProgressBarModule } from 'primeng/progressbar';
import { MessageDetails } from '../../Models/messageDetails';
import { PlockapiService } from '../../../services/plockapi.service';
import { StorageService } from '../../../services/storage.service';
import { MessageService } from 'primeng/api';
import { TagModule } from 'primeng/tag';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ToggleButtonModule } from 'primeng/togglebutton';


@Component({
  selector: 'app-home',
  standalone: true,
  imports: [
    FormsModule,
    CommonModule,
    RouterOutlet,
    ButtonModule,
    CardModule,
    ToolbarModule,
    AvatarModule,
    DevicelistComponent,
    TerminalComponent,
    DividerModule,
    PanelModule,
    ProgressBarModule,
    TagModule,
    ProgressSpinnerModule,
    ToggleButtonModule
  ],
  templateUrl: './home.component.html',
  styleUrl: './home.component.css',
  providers: [MessageService]
})
export class HomeComponent implements OnInit {
  title = 'Plataforma CMD';
  device: any = '';
  loadingHistory: boolean = false;
  unselected: boolean = true;
  history: MessageDetails[] = [];
  user: any;
  webVersion: string = "";
  themeOn: boolean = false;

  constructor(private _service: PlockapiService, private _storage: StorageService, private _messageService: MessageService) { }

  ngOnInit(): void {

    this._service.getAppVersion().subscribe({
      next: res => {
        let currentVersion = this._storage.getStoredDataByKey('webversion');
        if (currentVersion) {
          if(res > currentVersion) {
            this._storage.storeData('webversion', res);
            window.location.href = window.location.href + '?cacheBuster=' + new Date().getTime();
          }
        }
        else
          this._storage.storeData('webversion', res);

          this.webVersion = this._storage.getStoredDataByKey('webversion');
      },
      error: err => console.log(err)
    });

    this.user = this._storage.getStoredUser();
  }

  updateTerminal(event: any) {
    this.device = event;
    this.unselected = false;
    this.loadingHistory = true;
    if (this.device.code) {
      this._service.getChatHistory(this.device.code).subscribe({
        next: res => {
          this.history = res;
          this.loadingHistory = false;
        },
        error: err => {
          this.loadingHistory = false;
          console.log(err);
        }
      });
    }
  }

  logout() {
    this._storage.removeLocalUser()
  }

}
